import {AllGuestPosts} from '~/ViewInvitation/routes/Guests/AllGuestPosts';
import {RsvpLabel} from '~/ViewInvitation/routes/Guests/RsvpLabel';

export const Guestlist = (props) => {
  const {replies, query, openCommentEditor, setOpenCommentEditor, rsvpDetails, removeAds} = props;

  return replies.map((label) => {
    const rsvps = rsvpDetails[label];
    const filteredGuests = Object.values(rsvps).filter((guest) =>
      guest.guest_name.toLowerCase().includes(query.toLowerCase())
    );
    return (
      <div
        key={`label__${label}`}
        className="wic__guestlist-section"
        data-qa-id={`${label}-guestlist`}
      >
        <RsvpLabel label={label} query={query} />
        <AllGuestPosts
          label={label}
          guests={filteredGuests}
          openCommentEditor={openCommentEditor}
          onCommentEditorOpen={setOpenCommentEditor}
          onCommentEditorClose={() => setOpenCommentEditor(undefined)}
          removeAds={removeAds}
        />
      </div>
    );
  });
};
